// extracted by mini-css-extract-plugin
export default {"label":"_7JoaRbN7HFg9nMttAMITlQ=="};